"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._EuiShadowSizesDescriptions = exports.EuiThemeShadowSizes = void 0;
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

var EuiThemeShadowSizes = exports.EuiThemeShadowSizes = ['xs', 's', 'm', 'l', 'xl'];
/**
 * Shadow t-shirt sizes descriptions
 */
var _EuiShadowSizesDescriptions = exports._EuiShadowSizesDescriptions = {
  xs: 'Very subtle shadow used on small components.',
  s: 'Adds subtle depth, usually used in conjunction with a border.',
  m: 'Used on small sized portalled content like popovers.',
  l: 'Primary shadow used in most cases to add visible depth.',
  xl: 'Very large shadows used for large portalled style containers like modals and flyouts.'
};
//# sourceMappingURL=shadow.js.map